// extracted by mini-css-extract-plugin
export default {"overlay":"Kw-z","bodyOpen":"Lw-z","content":"Mw-z","header":"Nw-z","close":"Ow-z","closeNoHeading":"Pw-z"};